import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { DeleteMarketingFlowStepPayload } from "../../marketing.types";
import { requestDeleteMarketingFlowStep } from "./deleteMarketingFlowStep.request";

const useDeleteMarketingFlowStep = (
  options?: MutationOptions<
    { ok: boolean },
    ApiServiceError<ApiError>,
    DeleteMarketingFlowStepPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteMarketingFlowStep,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteMarketingFlowStep;
